var _stop, _stop2, _stop3, _stop4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "transaction_management_svg__a_".concat(unique)
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A68FF",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F94FF",
    offset: "21.055%"
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DBEFF",
    offset: "75.824%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFF3",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M10.795 2.001c3.37-.06 6.208 2.627 6.324 5.997a6.187 6.187 0 01-.898 3.438c1.31.095 2.254.953 2.679 1.59.107.134.147.42.024.707a.167.167 0 01-.074.079l-7.686 4.22H1.18a.18.18 0 01-.18-.18v-7.476a.18.18 0 01.18-.18h3.838a6.215 6.215 0 015.777-8.195zm-7.093 9.096H2.081c-.1 0-.18.08-.18.18v5.674a.18.18 0 00.18.18h1.621a.18.18 0 00.18-.18v-5.674a.18.18 0 00-.18-.18zm1.394 0h-.313v6.025h6.077l7.04-3.826-.112-.111c-.512-.507-1.58-1.457-2.984-.614-1.365.759-3.337 1.82-3.337 1.82l-.026.013c-.21.097-1.631.711-3.311.29l-2.276-.454-.015-.007a.383.383 0 01-.313-.36.396.396 0 01.218-.355.341.341 0 01.247-.034l2.29.452c1.726.223 2.266.043 2.854-.274l-6.04-2.565zM10.994 2.9a5.314 5.314 0 00-4.85 7.667l5.93 2.458c.758-.455 1.517-.91 2.275-1.213.221-.104.45-.189.686-.254a5.292 5.292 0 001.18-3.623c-.143-2.775-2.442-4.99-5.22-5.035zM9.396 5.346l1.51 1.51 1.513-1.51a.18.18 0 01.208-.034l.046.034.383.382a.18.18 0 01.033.208l-.033.047-.96.958h.703c.1 0 .18.081.18.18v.541a.18.18 0 01-.18.18h-1.441v.802h1.441a.18.18 0 01.18.18v.541c0 .1-.08.18-.18.18h-1.441v1.372c0 .1-.08.18-.18.18h-.54a.18.18 0 01-.18-.18l-.001-1.373-1.44.001a.18.18 0 01-.181-.18v-.54a.18.18 0 01.18-.18h1.44V7.84l-1.44.001a.18.18 0 01-.18-.18v-.54a.18.18 0 01.18-.18h.702l-.959-.959a.18.18 0 010-.255l.383-.382a.18.18 0 01.254 0z",
    fill: "url(#transaction_management_svg__a_".concat(unique, ")"),
    fillRule: "nonzero"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionManagement);
export default __webpack_public_path__ + "static/assets/transaction_management.d904bbd3.svg";
export { ForwardRef as ReactComponent };